<template>
  <div>
    <el-container>
      <el-main>
        <el-row>
          <el-col :span="24">
            <InternalRequestByModuleReportFilter
              @onYearSelected="OnYearSelected"
              @OnDirectionSelected="OnDirectionSelected"
              @EmployeeSelected="OnEmployeeSelected"
            />
            <!-- <ReportByProductByMonthFilters
              @onYearSelected="OnYearSelected"
              @thecnicianChaged="OnThecnicianChaged"
              @customerServiceChanged="OnCustomerServiceChanged"
              @resquestTypeChanged="OnRequestTypeChanged"
            /> -->
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <InternalRequestByModuleMonthlyReportTable
              :YearFilter="SelectedYear"
              :DirectionFilter="SelectedDirection"
              :EmployFilter="SelectedEmploy"
              @OpeningDetailDialosg="OnDetailDialogOpen"
            />
            <!-- <ReportByModuleByMonthTable
              :yearSelected="yearSelected"
              :thecnicianSelected="thecnicianSelected"
              :customerServiceCode="customerServiceCode"
              :requestTypeSelected="requestTypeSelected"
              @OpeningDetailDialosg="OnDetailDialogOpen"
            /> -->
          </el-col>
        </el-row>
        <InternalRequestsByModuleReportDetail
          :DialoVisible="detailDialogVisible"
          :DirectionId="SelectedDirection"
          :EmployId="SelectedEmploy"
          :Year="SelectedYear"
          :MonthSelected="monthSelected"
          :ReportId="reportId"
          :ReportName="reportName"
          :ModuleId="moduleId"
          :ModuleName="moduleName"
          @ClosingDialog="OnDetailDialogClose"
        />
        <!-- <MonthlyRequstsByModulesReportDetail
          :DialoVisible="detailDialogVisible"
          :YearSelected="yearSelected"
          :ThecnicianSelected="thecnicianSelected"
          :CustomerServiceCode="customerServiceCode"
          :Month="monthSelected"
          :ModuleId="moduleId"
          :ModuleName="moduleName"
          :RequestTypeSelected="requestTypeSelected"
          @ClosingDialog="OnDetailDialogClose"
        /> -->
      </el-main>
    </el-container>
  </div>
</template>

<script>
import InternalRequestByModuleMonthlyReportTable from "@/components/internal_requests/reports/InternalRequestByModuleMonthlyReport/InternalRequestByModuleMonthlyReportTable";
import InternalRequestByModuleReportFilter from "@/components/internal_requests/reports/InternalRequestByModuleMonthlyReport/filters/InternalRequestByModuleReportFilter";
import InternalRequestsByModuleReportDetail from "@/components/internal_requests/reports/InternalRequestByModuleMonthlyReport/details/InternalRequestsByModuleReportDetail";

const actualYear = new Date().getFullYear();

export default {
  name: "InternalRequestByModuleMontlyReport",
  components: {
    InternalRequestByModuleMonthlyReportTable,
    InternalRequestByModuleReportFilter,
    InternalRequestsByModuleReportDetail
  },
  data() {
    return {
      detailDialogVisible: false,
      SelectedYear: actualYear,
      SelectedDirection: "",
      SelectedEmploy: "",
      monthSelected: "",
      reportId: "",
      reportName: "",
      moduleId: "",
      moduleName: ""
    };
  },

  mounted() {},

  methods: {
    OnYearSelected(year) {
      this.SelectedYear = year;
    },
    OnDirectionSelected(direction) {
      this.SelectedDirection = direction;
    },
    OnEmployeeSelected(employ) {
      this.SelectedEmploy = employ;
    },
    OnDetailDialogClose(val) {
      this.detailDialogVisible = val;
    },
    OnDetailDialogOpen(val, month, moduleId, moduleName, reportId, reportName) {
      this.monthSelected = month;
      this.moduleId = moduleId;
      this.moduleName = moduleName;
      this.reportId = reportId;
      this.reportName = reportName;
      this.detailDialogVisible = val;
    }
  }
};
</script>

<style scoped></style>
